import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AuthLayout } from "@/features/auth/components/AuthLayout";
import { CheckCircle } from "lucide-react";

export const Route = createFileRoute("/verify")({
  component: VerifyPage,
});

function VerifyPage() {
  const { t } = useTranslation();

  return (
    <AuthLayout>
      <div className="flex flex-col items-center gap-4 py-4 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-success/10">
          <CheckCircle size={32} className="text-success" />
        </div>
        <h1 className="text-xl font-bold text-heading">{t("auth.verify.title")}</h1>
        <p className="text-sm text-muted">{t("auth.verify.subtitle")}</p>
        <Link
          to="/login"
          className="mt-4 inline-flex h-10 items-center justify-center rounded-lg bg-indigo px-6 text-sm font-semibold text-white transition-all hover:bg-indigo-bright hover:shadow-lg hover:shadow-indigo/25 active:scale-[0.98]"
        >
          {t("auth.verify.continueToLogin")}
        </Link>
      </div>
    </AuthLayout>
  );
}
